import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

//import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';

import { buildingModelGet, } from '../../models/buildings/building';
import {
    responseGet, globalSettings, styles, validateEmail, sendMessageCloseCurrentWindowAsync, buttonProcessGet, languageObjGet, isUndNullEmp, awaitDelay
} from '../../helpers/settings'
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'BuildingAdd';

export default function BuildingAdd({ processValues = {
    $: {},
    auth: {},
    showModal: {},
    setShowModal: false,
    userRole: '',
    building: buildingModelGet({ userId: '', }),
    setBuilding: () => { },
    dtBuildingsId: '',
    dtBuildingsRowIndex: 0,
    processType: 0,
    languageObj: GlobalFormats?.class(languageObjGet({ subMethod: currentMethod })?.result),
}, }) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    //#region old code
    //const buildingContractDateId = 'buildingContractDate';
    //#endregion old code
    const [descriptionError, setDescriptionError] = useState('');
    const [yearError, setYearError] = useState('');
    const [addressError, setAddressError] = useState('');
    const [emailError, setEmailError] = useState('');
    //#region old code
    //const [contractError, setContractError] = useState('');
    //const [coinBaseError, setCoinBaseError] = useState('')
    //const [coinOtherError, setCoinOtherError] = useState('')
    //const [dateError, setDateError] = useState('');
    //#endregion old code
    const controls = {
        buttons: {
            add: {
                className: 'btn btn-outline-warning',
                id: 'modalBtnAdd',
            },
            back: {
                className: 'btn btn-outline-success mx-1',
                id: 'modalBtnBack',
            },
        },
        dataTables: {
            // devices: {
            //     inputs: {
            //         search: {
            //             id: `${dtDevicesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtDevicesId}_length select`,
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            add: {
                id: 'modalIconAdd',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'modalIconBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        inputs: {
            name: {
                id: 'modalInpName',
                className: 'form-control',
            },
            year: {
                id: 'modalInpYear',
                className: 'form-control text-right',
            },
            address: {
                id: 'modalInpAddress',
                className: 'form-control',
            },
            email: {
                id: 'modalInpEmail',
                className: 'form-control',
            },
        },
        spinners: {
            add: {
                id: 'modalSpAdd',
                className: '',
            },
            back: {
                id: 'modalSpBack',
                className: '',
            },
        },
    };
    //#endregion variables

    //#region methods
    const defaultValueSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await errosDefaultSetAsync({ subMethod: currentMethod, });
            processValues?.setBuilding(buildingModelGet({ userId: processValues?.auth?.user?.id || '', }));
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            processValues?.setShowModal(false);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: processValues?.languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            processValues?.setBuilding({ ...processValues?.building, [property]: value, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: processValues?.languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: processValues?.building.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(globalSettings?.messages?.thisFieldRequired?.[processValues?.languageObj?.id]);
                response.isWarning = true;
            }

            if (parseInt(processValues?.building?.year) <= 0) {
                setYearError(globalSettings?.messages?.thisFieldRequired?.[processValues?.languageObj?.id]);
                response.isWarning = true;
            } else if (processValues?.building?.year?.toString()?.length !== 4) {
                setYearError(`${globalSettings?.messages?.thisFieldRequired?.[processValues?.languageObj?.id]}. 4 ${globalSettings?.labels?.characters}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: processValues?.building.address, subMethod: currentMethod, })?.result) {
                setAddressError(`${globalSettings?.messages?.thisFieldRequired?.[processValues?.languageObj?.id]}`);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: processValues?.building?.email, subMethod: currentMethod, })?.result && !validateEmail({ email: processValues?.building?.email, })) {
                setEmailError(`${globalSettings?.messages?.youMustEnterValidEmail?.[processValues?.languageObj?.id]}`);
                response.isWarning = true;
            }

            //#region old code
            // if (isEmpty(processValues?.building.coinBaseId)) {
            //     setCoinBaseError(`${globalSettings?.messages?.thisFieldRequired?.[processValues?.languageObj?.id]}`);
            //     response.isWarning = true;
            // }
            //#endregion old code
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: processValues?.languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errosDefaultSetAsync';
        let response = responseGet();
        try {
            setDescriptionError('');
            setYearError('');
            setAddressError('');
            setEmailError('');
            //setContractError('');
            //setCoinBaseError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: processValues?.languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region old code
            // response = dateInControlSet({
            //     date: new Date(),
            //     buildingContractDate: processValues?.building?.contractDate,
            //     subMethod: currentMethod,
            // });

            // if (!response?.isSuccess || response?.isWarning) {
            //     sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
            //     return;
            // }
            //#endregion old code
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: processValues?.languageObj?.id,
                subMethod: currentMethod,
            });
            await defaultValueSetAsync({ subMethod: currentMethod, });
        }
    }

    //#region old code
    // const dateInControlSet = ({ date = new Date(), buildingContractDate = {}, subMethod = '', }) => {
    //     const currentMethod = 'dateInControlSet';
    //     let response = responseGet();
    //     try {
    //         //#region old code
    //         //let dateTimeObj?.date = '';
    //         //const dateTimeObj?.dateFormat = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
    //         //const dateTimeObj?.dateFormatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
    //         //const dateTimeObj?.timeFormatTwo = globalSettings?.react?.tempusDominus?.formatTimehhmmA;
    //         //#endregion old code
    //         const dateTimeObj = {
    //             date: '',
    //             //dateFormat: globalSettings?.react?.tempusDominus?.format?.date?.dmy,
    //             //dateFormatTwo: globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY,
    //             dateFormat: processValues?.languageObj?.format?.date?.f1,
    //             dateFormatTwo: processValues?.languageObj?.format?.date?.f11,
    //             timeFormat: processValues?.languageObj?.format?.time?.type,
    //             timeFormatTwo: globalSettings?.react?.tempusDominus?.format?.time?.hhmmA,
    //             //timeFormatTwo: globalSettings?.react?.tempusDominus?.format?.time?.HHmm,
    //         };

    //         //console?.log(processValues?.languageObj);

    //         if (!isUndNullEmp({ data: buildingContractDate, subMethod: currentMethod, })?.result) {
    //             dateTimeObj.date = dateTimeFormatGlobalSet({
    //                 date: buildingContractDate,
    //                 type: dateTimeObj?.dateFormat,
    //                 format: dateTimeObj?.timeFormat,
    //                 addTime: false,
    //                 languageId: processValues?.languageObj?.id,
    //                 subMethod: currentMethod,
    //             }).result;
    //         } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
    //             //dateTimeObj.date = dateTimeFormatGlobalSet(date, dateTimeObj?.dateFormat, 12, false).result;
    //             dateTimeObj.date = dateTimeFormatGlobalSet({
    //                 date: date,
    //                 type: dateTimeObj?.dateFormat,
    //                 format: dateTimeObj?.timeFormat,
    //                 addTime: false,
    //                 languageId: processValues?.languageObj?.id,
    //                 subMethod: currentMethod,
    //             }).result;
    //         }

    //         processValues.$.fn.datetimepicker.Constructor.Default = processValues?.$.extend({}, processValues?.$.fn.datetimepicker.Constructor.Default, {
    //             icons: globalSettings?.react?.tempusDominus?.icons,
    //             buttons: globalSettings?.react?.tempusDominus?.buttons,
    //             tooltips: globalSettings?.react?.tempusDominus?.tooltips,
    //             //locale: 'es',
    //             locale: processValues?.languageObj?.id,
    //         });

    //         processValues?.$(`#${buildingContractDateId}`)?.datetimepicker({
    //             date: moment(dateTimeObj?.date, `${dateTimeObj?.dateFormatTwo} ${dateTimeObj?.timeFormatTwo}`),
    //             default: false,
    //             format: `${dateTimeObj?.dateFormatTwo} ${dateTimeObj?.timeFormatTwo}`,
    //         });
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const buildingAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buildingAddPostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            //#region old code
            // response = await dataBuildingSetAsync({subMethod: currentMethod, });
            // if (!response?.isSuccess || response?.isWarning) {
            //     return;
            // }
            //#endregion old code

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildings}/`,
                building: processValues?.building,
                languageId: processValues?.languageObj?.id,
            }

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );
            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: processValues?.languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //processValues.building = response.result;
            processValues.building = response?.result?.building;
            processValues.$(`#${processValues?.dtBuildingsId}`)?.DataTable()?.row?.add([
                processValues?.building?.description,
                //isUndNullEmp({ data: processValues?.building?.contractId, subMethod: currentMethod, })?.result ? globalSettings?.labels?.undefined?.[processValues?.languageObj?.id] : processValues?.building?.contractId,
                //processValues?.building?.contractId || '',
                processValues?.building?.contractId || globalSettings?.labels?.undefined?.[processValues?.languageObj?.id],
                buttonProcessGet({
                    id: processValues?.building?.id,
                    description: processValues?.building?.description,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.detail?.[processValues?.languageObj?.id],
                    enabledDetails: true,
                    showEdit: true,
                    labelEdit: globalSettings?.labels?.edit?.[processValues?.languageObj?.id],
                    enabledEdit: true,
                    showDelete: true,
                    labelDelete: globalSettings?.labels?.delete?.[processValues?.languageObj?.id],
                    enabledDelete: true,
                    processButtons: [],
                    subMethod: currentMethod
                })?.result
            ])?.draw(true);

            await defaultValueSetAsync({ subMethod: currentMethod, });
            //#endregion data save

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            //sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[processValues?.languageObj?.id], 0, true, false, null, '');
            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[processValues?.languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: processValues?.languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: processValues?.languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localGenerateContractAsync = async (e) => {
    //     let response = responseGet();
    //     try {
    //         e.preventDefault();
    //         await sendMessageCloseCurrentWindowAsync(0, 'Generate contractId here...!!!', false, response.urlGoTo, processValues.auth);
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localGenerateContractAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, processValues.auth);
    //     }
    // }
    //#endregion old code

    //#region old code
    // const dataBuildingSetAsync = async ({ subMethod = '', }) => {
    //     const currentMethod = 'dataBuildingSetAsync';
    //     let response = responseGet();
    //     try {
    //         const localBuildingDate = processValues.$(`#${buildingContractDateId}`)?.datetimepicker('date')?._d;
    //         processValues.building.contractDate = !isUndefined(localBuildingDate) ? localBuildingDate : processValues?.building?.contractDate;
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: processValues?.auth,
    //             isLogout: false,
    //             languageId: processValues?.languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //     }
    //     return response;
    // }
    //#endregion old code

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    processValues?.$(`#${controls?.icons?.add?.id}`)?.removeClass();
                    processValues?.$(`#${controls?.buttons?.add?.id}`)?.removeClass();
                    processValues?.$(`#${controls?.spinners?.add?.id}`)?.removeClass();

                    processValues?.$(`#${controls?.icons?.back?.id}`)?.removeClass();
                    processValues?.$(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    processValues?.$(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    processValues?.$(`#${controls?.icons?.add?.id}`)?.addClass(controls?.icons?.add?.className);
                    processValues?.$(`#${controls?.buttons?.add?.id}`)?.addClass(controls?.buttons?.add?.className);
                    processValues?.$(`#${controls?.spinners?.add?.id}`)?.addClass(controls?.spinners?.add?.className);

                    processValues?.$(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    processValues?.$(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    processValues?.$(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);
                    break;
                case 1:
                    //processValues?.$(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${globalSettings.react.html.button.classes.progress}`);
                    processValues?.$(`#${controls?.buttons?.add?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                    processValues?.$(`#${controls?.icons?.add?.id}`)?.removeClass();
                    processValues?.$(`#${controls?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    //processValues?.$(`#${controls?.buttons?.login?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${globalSettings.react.html.button.classes.progress}`);
                    processValues?.$(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                    processValues?.$(`#${controls?.icons?.back?.id}`)?.removeClass();
                    processValues?.$(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;

            }

            //#region old code
            // processValues?.$(`#${controls.dataTables.devices.inputs.search.id}`).attr('readOnly', (processType !== 0));
            // processValues?.$(`#${controls.dataTables.devices.selects.entries.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            processValues?.$(`#${controls?.inputs?.name?.id}`).attr('readOnly', (processType !== 0));
            processValues?.$(`#${controls?.inputs?.year?.id}`).attr('readOnly', (processType !== 0));
            processValues?.$(`#${controls?.inputs?.address?.id}`).attr('readOnly', (processType !== 0));
            processValues?.$(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));

            if (processType !== 0) {
                processValues?.$(`#${controls?.buttons?.add?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                processValues?.$(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.isSuccess = false;
            response.msgType = -1;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form', });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={processValues?.showModal} onHide={() => processValues?.setShowModal(false)}>
            <Modal.Header>
                <Modal.Title>
                    {/* <img alt={globalSettings?.labels?.building?.[processValues?.languageObj?.id]} src={globalSettings?.images?.buildingsLogo} style={styles?.cardHeaderLogo}></img> - {globalSettings?.labels?.building?.[processValues?.languageObj?.id]} - {processValues?.processType === 0 ? globalSettings?.labels?.add?.[processValues?.languageObj?.id] : globalSettings?.labels?.edit?.[processValues?.languageObj?.id]} */}
                    <img alt={globalSettings?.labels?.building?.[processValues?.languageObj?.id]} src={globalSettings?.images?.buildingsLogo} style={styles?.cardHeaderLogo}></img> - {processValues?.processType === 0 ? globalSettings?.labels?.add?.[processValues?.languageObj?.id] : globalSettings?.labels?.edit?.[processValues?.languageObj?.id]}
                </Modal.Title>
                <button type='button'
                    className='close btn-danger fas fa-window-close'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ subMethod: 'modal - btnHeadClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processValues?.processType === 0 ? buildingAddPostAsync({ e: e, subMethod: 'modal - form', }) : e?.preventDefault()}>
                <Modal.Body>
                    {/* <div className='card'> */}
                    {/* <form onSubmit={(e) => processValues?.processType === 0 ? buildingAddPostAsync(e) : localBuildingEditPostAsync(e)}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={globalSettings?.labels?.building?.[processValues?.languageObj?.id]} src={globalSettings?.images?.buildingsLogo} style={styles?.cardHeaderLogo}></img> - {globalSettings?.labels?.building?.[processValues?.languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* Body */}
                    {/* <div className='card-body pt-0'> */}
                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.name?.id}
                                //autoFocus
                                className={controls?.inputs?.name?.className}
                                placeholder={globalSettings?.labels?.name?.[processValues?.languageObj?.id]}
                                onChange={(e) => formDataSetAsync({ property: 'description', value: e?.target?.value, subMethod: 'input - description', })}
                                onFocus={() => setDescriptionError('')}
                                value={!isUndNullEmp({ data: processValues?.building?.description, subMethod: 'input - description' })?.result ? processValues?.building?.description : ''}
                                tooltip='tooltip'
                                title={globalSettings?.labels?.name?.[processValues?.languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={globalSettings?.icons?.building} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                    </div>

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.year?.id}
                                className={controls?.inputs?.year?.className}
                                placeholder={globalSettings?.labels?.year?.[processValues?.languageObj?.id]}
                                onChange={(e) => formDataSetAsync({ property: 'year', value: e?.target?.value, subMethod: 'input - year', })}
                                onFocus={() => setYearError('')}
                                tooltip='tooltip'
                                title={globalSettings?.labels?.year?.[processValues?.languageObj?.id]}
                                type='number'
                                min={1800}
                                max={new Date()?.getFullYear()}
                                //value={!isUndefined(processValues?.building.year) && processValues?.building.year !== 0 ? processValues?.building.year : formDataSetAsync('year', new Date()?.getFullYear())} />
                                value={!isUndNullEmp({ data: processValues?.building?.year, subMethod: 'input - year', })?.result && processValues?.building?.year !== 0 ? processValues?.building?.year : new Date()?.getFullYear()} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={globalSettings?.icons?.sortNumericUpAlt} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(yearError)}</div>
                    </div>

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <textarea id={controls?.inputs?.address?.id}
                                className={controls?.inputs?.address?.className}
                                placeholder={globalSettings?.labels?.address?.[processValues?.languageObj?.id]}
                                onChange={(e) => formDataSetAsync({ property: 'address', value: e?.target?.value, subMethod: 'input - address', })}
                                onFocus={() => setAddressError('')}
                                value={!isUndNullEmp({ data: processValues?.building?.address, subMethod: 'input - address', })?.result ? processValues?.building?.address : ''}
                                tooltip='tooltip'
                                title={globalSettings?.labels?.address?.[processValues?.languageObj?.id]}>
                            </textarea>
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className='fas fa-map-marked-alt' />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(addressError)}</div>
                    </div>

                    <div className='form-group'>
                        <div className='input-group mb-3'>
                            <input id={controls?.inputs?.email?.id}
                                className={controls?.inputs?.email?.className}
                                placeholder={globalSettings?.labels?.email?.[processValues?.languageObj?.id]}
                                onChange={(e) => formDataSetAsync({ property: 'email', value: e?.target?.value, subMethod: 'input - email', })}
                                onFocus={() => setEmailError('')}
                                value={!isUndNullEmp({ data: processValues?.building?.email, subMethod: 'input- email' })?.result ? processValues?.building?.email : ''}
                                tooltip='tooltip'
                                title={globalSettings?.labels?.email?.[processValues?.languageObj?.id]} />
                            <div className='input-group-append'>
                                <div className='input-group-text'>
                                    <span className={globalSettings?.icons?.envelope} />
                                </div>
                            </div>
                        </div>
                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(emailError)}</div>
                    </div>

                    {/* <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input className='form-control'
                                                placeholder={globalSettings?.labels?.contract?.[processValues?.languageObj?.id]}
                                                onChange={(e) => formDataSetAsync('contractId', e.target.contractId)}
                                                onFocus={() => setContractError('')}
                                                value={!isUndefined(processValues) && !isNull(processValues) && !isEmpty(processValues) &&
                                                    !isUndefined(processValues?.building.contractId) && !isNull(processValues?.building.contractId) ?
                                                    processValues?.building.contractId : ''}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.contract?.[processValues?.languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.fileInvoice} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(contractError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            {!isUndefined(processValues?.building) && !isUndefined(processValues?.building.contractDate) ?
                                                <div className='input-group date' id={buildingContractDateId} data-target-input='nearest'>
                                                    <input className='form-control datetimepicker-input'
                                                        data-target={`#${buildingContractDateId}`}
                                                        data-toggle='datetimepicker'
                                                        onFocus={() => setDateError('')}
                                                        placeholder={globalSettings?.labels?.date?.[processValues?.languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={globalSettings?.labels?.date?.[processValues?.languageObj?.id]}
                                                        type='text' />
                                                    <div className='input-group-append' data-target={`#${buildingContractDateId}`} data-toggle='datetimepicker'>
                                                        <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                                    </div>
                                                </div>
                                                : <></>}
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                    </div>
                                </div>
                            </div> */}

                    {/* <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            {!isUndefined(processValues) && !isNull(processValues) && !isEmpty(processValues) &&
                                                !isUndefined(processValues?.coins) ?
                                                <select defaultValue={processValues?.building.coinBaseId}
                                                    className='form-select'
                                                    onChange={(e) => formDataSetAsync('coinBaseId', e?.target?.value)}
                                                    onFocus={() => setCoinBaseError('')}>
                                                    <option key='nothing' value=''>{globalSettings?.labels?.selectCoinBase}</option>
                                                    {processValues?.coins.map((coin) => <option key={coin.id} value={coin.id}>{coin.description}</option>)};
                                                </select> :
                                                <></>}
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-processValues?.coins' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(coinBaseError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            {!isUndefined(processValues) && !isNull(processValues) && !isEmpty(processValues) &&
                                                !isUndefined(processValues?.coins) ?
                                                <select defaultValue={processValues?.building.coinOtherId}
                                                    className='form-select'
                                                    onChange={(e) => formDataSetAsync('coinOtherId', e?.target?.value)}
                                                    onFocus={() => setCoinOtherError('')}>
                                                    <option key='nothing' value=''>{globalSettings?.labels?.selectCoinOther}</option>
                                                    {processValues?.coins.map((coin) => <option key={coin.id} value={coin.id}>{coin.description}</option>)};
                                                </select> :
                                                <></>}
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-comments-dollar' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(coinOtherError)}</div>
                                    </div>
                                </div>
                            </div> */}
                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning'
                                    tooltip='tooltip'
                                    title={processValues?.processType === 0 ? globalSettings?.labels?.add?.[processValues?.languageObj?.id] : globalSettings?.labels?.save?.[processValues?.languageObj?.id]}
                                    type='submit'>
                                    <i className={globalSettings?.icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-info mx-1'
                                    tooltip='tooltip'
                                    title={globalSettings?.labels?.createContract}
                                    type='button'
                                    onClick={(e) => localGenerateContractAsync(e)}
                                    disabled={!(processValues?.userRole === globalSettings?.roles?.master || processValues?.userRole === globalSettings?.roles?.admin)} >
                                    <i className={globalSettings?.icons?.fileInvoice}></i>
                                </button>
                                <button className='btn btn-outline-success mx-1'
                                    tooltip='tooltip'
                                    title={globalSettings?.labels?.close?.[processValues?.languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync()}>
                                    <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.add?.id}
                            className={controls?.buttons?.add?.className}
                            tooltip='tooltip'
                            title={processValues?.processType === 0 ? globalSettings?.labels?.add?.[processValues?.languageObj?.id] : globalSettings?.labels?.save?.[processValues?.languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.add?.id} className={controls?.icons?.add?.className} /> <span id={controls?.spinners?.add?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[processValues?.languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ subMethod: 'modal - btnClose', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}